import { ATTRACTIONS } from "@/lib/site-data";

export default function WhyChooseUs() {
  const [A0, A1, A2, A3, A4] = ATTRACTIONS;
  const Icon0 = A0.Icon;
  const Icon1 = A1.Icon;
  const Icon2 = A2.Icon;
  const Icon3 = A3.Icon;
  const Icon4 = A4.Icon;

  return (
    <section
      id="atractivos"
      data-testid="why-choose-us-section"
      className="relative bg-[#F5F3EE] text-[#0A0A0A] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Heading */}
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="block w-8 h-px bg-[#006961]" />
              <span className="overline" style={{ color: "#006961" }}>
                03 · Atractivos LUXE
              </span>
            </div>
            <h2 className="heading-lg text-3xl sm:text-4xl lg:text-5xl text-[#0A0A0A]">
              ¿Por qué elegir
              <br />
              <span className="text-[#006961]">DISEÑO Y CONSTRUCCIÓN LUXE?</span>
            </h2>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-px bg-black/10">
          {/* Big feature 01 */}
          <div className="md:col-span-3 md:row-span-2 bg-white p-8 md:p-12 relative group hover:bg-[#FAFAF7] transition-colors">
            <span className="font-heading text-7xl lg:text-8xl text-[#385723]/15 absolute top-6 right-8 group-hover:text-[#385723]/30 transition-colors">
              {A0.num}
            </span>
            <Icon0
              className="w-10 h-10 text-[#385723] mb-8 relative z-10"
              strokeWidth={1.5}
            />
            <h3 className="heading-md text-2xl lg:text-3xl text-[#0A0A0A] mb-4 relative z-10">
              {A0.title}
            </h3>
            <p className="font-body text-[#3a3a3a] leading-relaxed relative z-10 mb-6">
              {A0.description}
            </p>
            <div className="diag-accent h-2 w-32 mt-auto" />
          </div>

          {/* 02 */}
          <div className="md:col-span-3 bg-white p-8 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-4">
              <Icon1 className="w-7 h-7 text-[#006961]" strokeWidth={1.5} />
              <span className="font-heading text-xs tracking-[0.3em] text-[#767171] uppercase">
                {A1.num}
              </span>
            </div>
            <h3 className="heading-md text-xl text-[#0A0A0A] mb-3">{A1.title}</h3>
            <p className="font-body text-sm text-[#3a3a3a] leading-relaxed">
              {A1.description}
            </p>
          </div>

          {/* 03 */}
          <div className="md:col-span-3 bg-white p-8 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-4">
              <Icon2 className="w-7 h-7 text-[#385723]" strokeWidth={1.5} />
              <span className="font-heading text-xs tracking-[0.3em] text-[#767171] uppercase">
                {A2.num}
              </span>
            </div>
            <h3 className="heading-md text-xl text-[#0A0A0A] mb-3">{A2.title}</h3>
            <p className="font-body text-sm text-[#3a3a3a] leading-relaxed">
              {A2.description}
            </p>
          </div>

          {/* 04 */}
          <div className="md:col-span-3 bg-white p-8 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-4">
              <Icon3 className="w-7 h-7 text-[#385723]" strokeWidth={1.5} />
              <span className="font-heading text-xs tracking-[0.3em] text-[#767171] uppercase">
                {A3.num}
              </span>
            </div>
            <h3 className="heading-md text-xl text-[#0A0A0A] mb-3">{A3.title}</h3>
            <p className="font-body text-sm text-[#3a3a3a] leading-relaxed">
              {A3.description}
            </p>
          </div>

          {/* 05 */}
          <div className="md:col-span-3 bg-white p-8 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-4">
              <Icon4 className="w-7 h-7 text-[#006961]" strokeWidth={1.5} />
              <span className="font-heading text-xs tracking-[0.3em] text-[#767171] uppercase">
                {A4.num}
              </span>
            </div>
            <h3 className="heading-md text-xl text-[#0A0A0A] mb-3">{A4.title}</h3>
            <p className="font-body text-sm text-[#3a3a3a] leading-relaxed">
              {A4.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
